
import React from 'react';
import { AnimatedCard } from '@/components/ui/AnimatedCard';
import { CardContent } from '@/components/ui/card';
import { Gauge } from 'lucide-react';

const GasPressureKpi = () => {
  return (
    <AnimatedCard 
      animation="fade-up" 
      delay={300}
      className="bg-white dark:bg-gray-800 border-none"
    >
      <CardContent className="p-6 flex flex-col items-center">
        <div className="bg-amber-100 dark:bg-amber-900/20 p-3 rounded-full mb-4">
          <Gauge className="h-6 w-6 text-amber-600" />
        </div>
        <h3 className="text-xl font-medium text-gray-900 dark:text-gray-100">Pressure Level</h3>
        <p className="text-3xl font-bold mt-2 text-amber-600">5.8 bar</p>
        <p className="text-sm text-green-600 mt-1">Within optimal range</p>
      </CardContent>
    </AnimatedCard>
  );
};

export default GasPressureKpi;
